import { Grid } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { LoadPhoneNumbersGridData } from "../../actions";
import Config from "../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GoToPlansPrimaryIcon, GoToPlansSecondaryIcon, PaymentAwaitedIcon, PaymentFailedIcon, PaymentSuccessIcon, PrintIcon, TryAgainIcon } from "../../icon";
import { IInvoiceModel, mapChargebeeInvoice, PaymentStatus } from "../../models/payment.model";
import { PhoneNumberModel, PhoneNumberStatus } from "../../models/phone-number.model";
import { AppState } from "../../reducers/models";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels, ViewTextLabels } from "../shared/constants";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors";
import { useDispatch } from "react-redux";
import { updatePhoneNumbersGridData } from "../../reducers/reducer";

interface IProps {
  IsTeamsApp: boolean;
  Stepdata: any
}

const PaymentStatusComponent = (props: IProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let StatusInterval: NodeJS.Timeout;

  const [invoice, setInvoice] = useState<IInvoiceModel>()
  const [paymentStatus, setPaymentStatus] = useState(PaymentStatus.AWAITING)

  const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
  const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)


  useEffect(() => {
    let { status, isSingUp } = getData();
    if ((!PhoneNumbers || PhoneNumbers.length === 0) && !isSingUp) {
      LoadPhoneNumbersGridData(dispatch);
    }
    setPaymentStatus(status || PaymentStatus.AWAITING);

    if (!StatusInterval && (status === PaymentStatus.AWAITING || !status)) {
      StatusInterval = setInterval(getPaymentStatus, 2000)
      console.log("getPayment");
    }

    return () => { clearStatusInterval() };
  }, [])

  const clearStatusInterval = () => {
    if (StatusInterval) {
      clearInterval(StatusInterval)
    }
  }

  const getPaymentStatus = () => {
    let { paymentID, phoneNumberID } = getData();

    const PhoneNumber = PhoneNumbers.find(x => x.ID === phoneNumberID);



    if (paymentID) {
      axios.get(`${Config.CHARGEBEE_INTEGRATION_API_URL}/get-host-page?id=${paymentID}`,).then((response) => {
        let paymentStatus = !!response.data.hosted_page?.content?.invoice?.linked_payments?.every(x => x.txn_status === "success") ? PaymentStatus.SUCCESS : PaymentStatus.FAILED;
        setPaymentStatus(paymentStatus)
        setInvoice(paymentStatus === PaymentStatus.SUCCESS ? mapChargebeeInvoice(response.data.hosted_page.content.invoice) : undefined)
        // setInvoice(mapChargebeeInvoice(response.data.hosted_page.content.invoice))
        clearStatusInterval();
        if (!!PhoneNumber) {
          const data = PhoneNumbers.map(x => x.ID === PhoneNumber.ID ? { ...x, Status: PhoneNumberStatus.ACTIVE } : x)
          dispatch(updatePhoneNumbersGridData(data))
        }

      }).catch(error => { });
    }
    else {
      setPaymentStatus(PaymentStatus.FAILED)
    }
  }

  const getData = () => {
    if (props.Stepdata) {
      let obj = {
        phoneNumberID: props.Stepdata?.phoneNumberID,
        OrganizationID: props.Stepdata?.OrganizationID,
        phoneNumber: props.Stepdata?.PhoneNumber,
        planID: props.Stepdata?.planID,
        paymentID: props.Stepdata?.paymentID,
        Tenure: props.Stepdata?.Tenure,
        state: props.Stepdata?.state,
        IsSignUp: props.Stepdata?.IsSignUp,
        ID: props.Stepdata?.ID,
      }
      return { phoneNumberID: obj.phoneNumberID, OrganizationID: obj.OrganizationID, phoneNumber: obj.phoneNumber, planID: obj.planID, paymentID: obj.paymentID, Tenure: obj.Tenure, status: obj.state, isSingUp: obj.IsSignUp, id: obj.ID };
    }
    else if (location.state) {
      let { phoneNumberID, OrganizationID, phoneNumber, planID, paymentID, Tenure, state, IsSignUp, ID } = location.state as any
      return { phoneNumberID, OrganizationID, phoneNumber, planID, paymentID, Tenure, status: state, isSingUp: IsSignUp, id: ID };
    }
    else {
      let urlParams = new URLSearchParams(location.search);
      let phoneNumberID = urlParams.get("phoneNumberID") || "";
      let OrganizationID = urlParams.get("OrganizationID") || "";
      let phoneNumber = urlParams.get("phoneNumber") || "";
      let planID = urlParams.get("planID") || "";
      let paymentID = urlParams.get("id") || "";
      let Tenure = urlParams.get("Tenure") || "";
      let status = parseInt(urlParams.get("state") || "") as PaymentStatus;
      return { phoneNumberID, OrganizationID, phoneNumber, planID, paymentID, Tenure, status };
    }
  }
  const handlePrint = () => {
    window.print();
  }

  const goToHome = (e: any) => {
    e.preventDefault()
    if ((location.state as any)?.IsSignUp) {
      navigate(AppRoutes.SIGN_IN);
      return;
    }
    {
      UserService.hasSysAdminRole() ? (
        navigate(AppRoutes.PHONE_NUMBERS, { state: { OrganizationID } })
      ) : (
        navigate(AppRoutes.PLANS)
      );
    }
  }

  const handleTryAgain = () => {
    (global as any).paymentID = "";
    if (showTryAgain()) {
      navigate(location.pathname, { state: { ...(location.state as any), step: (location.state as any)?.step ? (location.state as any)?.step - 1 : 1 }, replace: true });
    }
  }

  const showTryAgain = () => {
    return location.pathname === AppRoutes.RECHARGE || location.pathname === AppRoutes.ADD_PHONE_NUMBER || location.pathname === AppRoutes.SIGN_UP
  }

  const formatNumber = number => {
    const [integerPart, decimalPart] = String(number).split('.');
    const paddedDecimalPart = decimalPart ? decimalPart.padEnd(2, '0') : '00';
    return `${integerPart || '0'}.${paddedDecimalPart}`;
  };

  let { phoneNumber, phoneNumberID, OrganizationID, planID } = getData();
  phoneNumber = phoneNumber || PhoneNumbers.find(x => x.ID === phoneNumberID)?.PhoneNumber;

  return (
    paymentStatus === PaymentStatus.SUCCESS ?
      <div className={`d-flex h-p-100 w-p-100 b-none ${(location.state as any)?.IsSignUp || ((location.state as any)?.IsRecharge && IsMobileDevice) ? '' : ''}  `}>

        <div className={` ${IsMobileDevice ? 'w-p-100' : 'w-p-90 settings-paper-border px-8  br-3  max-h-fill '} t-align-center printme`}>
          <div id="print">
            <div className={`pt-2`}> <PaymentSuccessIcon /> </div>
            <div className={`h1-semibold color-primary-success pb-1 pt-1`} >{appNote.PAYMENT_SUCCESSFUL} </div>

            <div className="h4-regular color-secondary-accent pb-4">{appNote.THANK_YOU_FOR_PAYMENT}<br /> {appNote.PROCESSED_SUCCESSFULLY}</div>
            <div className="bb-primary-background-pink-4"></div>

            <Grid container className={"mt-3"} direction="row" spacing={3}>
              <Grid item xs={IsMobileDevice ? 12 : 6} md={6}>
                <Grid container >
                  <Grid item xs={6} className={`h5-semibold color-primary-accent w-space t-align-left ${getData().paymentID.length > 22 ? ' pb-2' : 'pb-1'}`}>
                    {ViewTextLabels.TRANSACTION_ID}
                  </Grid>
                  <Grid item xs={6} className={`h6-regular my-auto t-align-left payment-status-word ${getData().paymentID.length > 22 ? 'mt-0 mb-auto' : 'my-auto'}`} id="print-font" >
                    {invoice?.SubscirptionID || getData().paymentID}
                  </Grid>
                  <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left pb-1 ${getData().paymentID.length > 22 ? 'pb-2' : 'pb-1'}`} style={getData().paymentID.length > 22 ? { paddingTop: '0.1rem' } : {}}>
                    {ViewTextLabels.PHONE_NUMBER}
                  </Grid>
                  <Grid item xs={6} className={`${getData().paymentID.length > 22 ? 'mt-0 mb-auto' : 'my-auto'} h6-regular t-align-left`} id="print-font" style={getData().paymentID.length > 22 ? { paddingTop: '0.1rem' } : {}}>
                    {UtilityService.maskPhoneNumber(phoneNumber)}
                  </Grid>
                  <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left pb-1`} >
                    {ViewTextLabels.PLANS}
                  </Grid>
                  <Grid item xs={6} className={`h6-regular t-align-left ${getData().paymentID.length > 22 ? 'mt-0 mb-auto' : 'my-auto'}`} id="print-font">
                    {invoice?.PlanItemName.substring(invoice?.PlanItemName.indexOf(' ') + 1) || "--"}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={IsMobileDevice ? 12 : 6} md={6}>
                <Grid container>
                  <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left ${getData().paymentID.length > 22 ? 'pb-2' : 'pb-1'} `}>
                    {ViewTextLabels.PRICE}
                  </Grid>
                  <Grid item xs={6} className={`h6-regular t-align-left ${getData().paymentID.length > 22 ? 'mt-0 mb-auto' : 'my-auto'}`} id="print-font">
                    {invoice?.PaidAmount > 0 && '$'}{invoice?.PaidAmount > 0 ? formatNumber(invoice?.PaidAmount / 100) : "--"}
                  </Grid>
                  <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left ${getData().paymentID.length > 22 ? 'pb-2' : 'pb-1'}`}>
                    {ViewTextLabels.INVOICE_ID}
                  </Grid>
                  <Grid item xs={6} className={`h6-regular w-space t-align-left ${getData().paymentID.length > 22 ? 'mt-0 mb-auto' : 'my-auto'}`} id="print-font">
                    {invoice?.ID}
                  </Grid>
                  <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left pb-1`}>
                    {ViewTextLabels.DATE}
                  </Grid>
                  <Grid item xs={6} className={`${getData().paymentID.length > 22 ? 'mt-0 mb-auto' : 'my-auto'} h6-regular t-align-left`} id="print-font">
                    {invoice?.PaidDateTime ? UtilityService.convertDateToDay(invoice?.PaidDateTime) : "--"}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>

          <div className={`${IsMobileDevice ? 'mx-auto' : 'd-flex t-align-center justify-center'} mt-3 mb-2 no-printme`}>
            <ButtonComponent OnClick={handlePrint}
              ButtonLabel={buttonLabels.PRINT.toLocaleUpperCase()}
              ClassName={`c-pointer  ${IsMobileDevice ? 'w-p-100 justify-center mb-2' : 'mr-2'} `}
              Variant={"secondary-btn-small"}
              Icon={PrintIcon}
            />
            <ButtonComponent OnClick={goToHome}
              ButtonLabel={(location.state as any)?.IsSignUp ? buttonLabels.BACK_TO_LOGIN : UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS}
              ClassName={`c-pointer  ${IsMobileDevice ? 'w-p-100 justify-center mb-2' : 'mr-2'}`}
              Variant={"primary-btn-small"}
              Icon={(location.state as any)?.IsSignUp ? undefined : GoToPlansPrimaryIcon}
            />
          </div >
        </div>
      </div >

      : paymentStatus === PaymentStatus.FAILED ?
        <div className={`d-flex px-auto w-fill h-p-100 ${(location.state as any)?.IsSignUp ? '' : 'paper-background'} mx-auto `}>
          <div className=" py-8 px-4 w-p-100 t-align-center printme b-around-text-field-border-4 br-3">
            <div id="print">
              <div className={`pt-4`}>
                <PaymentFailedIcon />
              </div>
              <div className={`h1-semibold pb-1 pt-1 color-primary-danger`}>
                {appNote.PAYMENT_FAILED}
              </div>

              <div className="h4-regular color-secondary-accent pb-4">{appNote.SOMETHING_WENT_WRONG}<br /> {appNote.TRY_AGAIN}</div>
            </div>

            <div className="d-flex t-align-center justify-center mt-5 mb-2 no-printme">
              {showTryAgain() && <ButtonComponent OnClick={() => handleTryAgain()}
                ButtonLabel={buttonLabels.TRY_AGAIN.toUpperCase()}
                ClassName={"c-pointer mr-2"}
                Variant={"primary-btn-small"}
                Icon={TryAgainIcon}
              />}
              <ButtonComponent OnClick={goToHome}
                ButtonLabel={(location.state as any)?.IsSignUp ? buttonLabels.BACK_TO_SIGN_UP : UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS}
                ClassName={"c-pointer mr-2"}
                Variant={"secondary-btn-small"}
                Icon={GoToPlansSecondaryIcon}
              />
            </div >
          </div>
        </div >
        : <div className={`d-flex px-auto w-fill h-p-100 ${(location.state as any)?.IsSignUp ? '' : 'paper-background'} mx-auto `}>
          <div className="px-4 w-p-100 t-align-center printme b-around-text-field-border-4 br-3">
            <div id="print">
              <div className={`pt-4`}>
                <PaymentAwaitedIcon />
              </div>
              <div className={`h1-semibold pb-1 pt-1 color-primary-warning`}>
                {appNote.PAYMENT_AWAITED}
              </div>

              <div className="h4-regular t-align-center color-secondary-accent pb-4">{appNote.PAYMENT_AWAITED_NOTE}</div>
            </div>

            <div className="d-flex t-align-center justify-center mt-5 no-printme">
              <ButtonComponent OnClick={goToHome}
                ButtonLabel={(location.state as any)?.IsSignUp ? buttonLabels.BACK_TO_SIGN_UP : UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS}
                ClassName={"c-pointer mr-2"}
                Variant={"primary-btn-small"}
                Icon={GoToPlansPrimaryIcon}
              />
            </div >
            <div className="footnote t-align-center color-secondary-accent pt-2">{appNote.PAYMENT_AWAITED_FOOT_NOTE}</div>
          </div>
        </div >
  )
}

export default PaymentStatusComponent;